import React from 'react'
import useNFTMetadata from '@hooks/useNFTMetadata'
import { useTranslation } from 'react-i18next'
import { Text } from '@components/Helpers'
import AvatarList from '../AvatarList'

const BoldText = {
  fontWeight: 'bold',
}

const Proposer = ({ proposerKey }: { proposerKey: string }) => {
  const { t } = useTranslation()
  const {
    content: {
      metadata,
      links: { image },
    },
  } = useNFTMetadata(proposerKey)

  return (
    <div className="flex flex-col items-start p-4 gap-2">
      <Text sx={BoldText}>
        {t('dao.proposalDetails.proposer', {
          proposer: metadata?.name,
        })}
      </Text>
      <AvatarList images={[image]} total={1} max={1} />
    </div>
  )
}

export default Proposer
